export const LOADING = 'loading';

// Message actions
export const DISPLAY_MESSAGE = 'display_message';
export const CLEAR_MESSAGE = 'clear_message';

// Admin action
export const LOAD_ADMINS_SUCCESS = 'load_admins_success';

// Login actions
export const CHANGE_LOGIN_EMAIL = 'change_login_email';
export const CHANGE_LOGIN_PASSWORD = 'change_login_password';
export const LOGIN_SUCCESS = 'login_success';
export const LOAD_USER_FROM_LOCAL_STORAGE = 'load_user_from_local_storage';

// Logout actions
export const LOGOUT_SUCCESS = 'logout_success';

// profile actions
export const UPDATE_PROFILE_SUCCESS = 'update_profile_success';
export const CHANGE_PASSWORD_SUCCESS = 'change_password_success';
export const USER_CAN_ACCESS_POS_SETTINGS = 'user_can_access_pos_settings';
export const USER_CAN_PAUSE_ALL_RESTAURANTS = 'user_can_pause_all_restaurants';

// restaurants actions
export const LOAD_RESTAURANTS_SUCCESS = 'load_restaurants_success';
export const LOAD_RESTAURANT_SUCCESS = 'load_restaurant_success';
export const SAVE_RESTAURANT_SUCCESS = 'save_restaurant_success';
export const SAVE_PAYMENT_SETTINGS_SUCCESS = 'save_payment_settings_success';
export const UPDATE_RESTAURANT_SUCCESS = 'update_restaurant_success';
export const LOAD_RESTAURANTS_SUMMARY_SUCCESS = 'load_restaurants_summary_success';
export const CLEAR_RESTAURANT = 'clear_restaurant';
export const CLEAR_RESTAURANTS = 'clear_restaurants';
export const GET_PAYMENT_PROVIDERS_SUCCESS = 'get_payment_providers_success';
export const LOAD_RESTAURANT_NOTES_SUCCESS = 'load_restaurant_notes_success';
export const SAVE_RESTAURANT_NOTES_SUCCESS = 'save_restaurant_notes_success';
export const CLEAR_RESTAURANT_NOTES = 'clear_restaurant_notes';

// restaurants pos settings
export const LOAD_POS_SETTINGS_SUCCESS = 'load_pos_settings_success';
export const LOAD_POS_TYPES_SUCCESS = 'load_pos_types_success';
export const UPDATE_POS_SETTINGS_SUCCESS = 'update_pos_settings_success';
export const CLEAR_POS_SETTINGS = 'clear_pos_settings';
export const CLEAR_RESTAURANT_SETTINGS = 'clear_restaurant_settings';

// restaurants order type mapping
export const LOAD_ORDER_TYPE_MAPPINGS_SUCCESS = 'load_order_type_mappings_success';
export const LOAD_POS_ORDER_TYPES_SUCCESS = 'load_poss_order_types_success';
export const UPDATE_ORDER_TYPE_MAPPINGS_SUCCESS = 'update_order_type_mappings_success';
export const IMPORT_POS_ORDER_TYPES_SUCCESS = 'import_pos_order_types_success';
export const CLEAR_ORDER_TYPE_MAPPINGS = 'clear_order_type_mappings';

// restaurants tender type mapping
export const LOAD_TENDER_TYPE_MAPPINGS_SUCCESS = 'load_tender_type_mappings_success';
export const LOAD_POS_TENDER_TYPES_SUCCESS = 'load_poss_tender_types_success';
export const UPDATE_TENDER_TYPE_MAPPINGS_SUCCESS = 'update_tender_type_mappings_success';
export const IMPORT_POS_TENDER_TYPES_SUCCESS = 'import_pos_tender_types_success';
export const CLEAR_TENDER_TYPE_MAPPINGS = 'clear_tender_type_mappings';

// restaurants charge type mapping
export const LOAD_CHARGE_TYPE_MAPPINGS_SUCCESS = 'load_charge_type_mappings_success';
export const LOAD_POS_CHARGE_TYPES_SUCCESS = 'load_pos_charge_types_success';
export const UPDATE_CHARGE_TYPE_MAPPINGS_SUCCESS = 'update_charge_type_mappings_success';
export const IMPORT_POS_CHARGE_TYPES_SUCCESS = 'import_pos_charge_types_success';
export const CLEAR_CHARGE_TYPE_MAPPINGS = 'clear_charge_type_mappings';

// restaurant days off type mapping
export const LOAD_DAYS_OFF_SUCCESS = 'load_days_off_mapping_success';
export const UPDATE_DAYS_OFF_SUCCESS = 'update_days_off_mapping_success';
export const RESET_DAYS_OFF = 'reset_days_off';

// Brand actions
export const CREATE_BRAND_SUCCESS = 'create_brand_success';
export const UPDATE_BRAND_SUCCESS = 'update_brand_success';
export const LOAD_BRAND_SUCCESS = 'load_brand_success';
export const LOAD_BRANDS_SUCCESS = 'load_brands_success';
export const CLEAR_BRAND = 'clear_brand';
export const CLEAR_BRANDS = 'clear_brands';
export const UPDATE_BRAND_IMAGE_SUCCESS = 'update_brand_image_succes';
export const UPDATE_BRAND_LOGO_SUCCESS = 'update_brand_logo_succes';
export const DELETE_BACKGROUND_IMAGE_SUCCESS = 'delete_background_image_success';

// Manager actions
export const LOAD_MANAGER_SUCCESS = 'load_manager_success';
export const SAVE_MANAGER_SUCCESS = 'save_manager_success';
export const CLEAR_MANAGER = 'clear_manager';

// timezone
export const LOAD_TIMEZONES_SUCCESS = 'load_timezones_success';

// Menu Configuration Screen

//Menus
export const LOAD_MENUS_SUCCESS = 'load_menus_success';
export const RESET_MENUS = 'reset_menus';
export const REORDER_MENUS_SUCCESS = 'reorder_menus_success';
export const LOAD_MENUS_FOR_CSV_CREATE_EDIT_SUCCESS = 'load_menus_for_csv_create_edit_success';

//Categories
export const LOAD_CATEGORIES_SUCCESS = 'load_categories_success';
export const RESET_CATEGORIES = 'reset_categories';
export const REORDER_CATEGORIES_SUCCESS = 'reorder_categories_success';
export const LOAD_CATEGORIES_FOR_CSV_CREATE_EDIT_SUCCESS = 'load_categories_for_csv_create_edit_success';
export const RESET_CATEGORIES_FOR_CSV_CREATE_EDIT_SUCCESS = 'reset_categories_for_csv_create_edit_success';

//Products
export const LOAD_PRODUCTS_SUCCESS = 'load_products_success';
export const RESET_PRODUCTS = 'reset_products';
export const REORDER_PRODUCTS_SUCCESS = 'reorder_products_success';
export const LOAD_PRODUCTS_FOR_CSV_CREATE_EDIT_SUCCESS = 'load_products_for_csv_create_edit_success';
export const RESET_PRODUCTS_FOR_CSV_CREATE_EDIT_SUCCESS = 'reset_products_for_csv_create_edit_success';
export const IS_PRODUCT_COPY = 'is_product_copy';
export const PRODUCT_COPY = 'product_copy';
export const IS_PRODUCT_EDIT = 'is_product_edit';
export const RESET_PRODUCT_COPY = 'reset_product_copy';

//Questions
export const LOAD_QUESTIONS_SUCCESS = 'load_questions_success';
export const RESET_QUESTIONS = 'reset_questions';
export const REORDER_QUESTIONS_SUCCESS = 'reorder_questions_success';
export const QUESTION_COPY = 'question_copy';
export const IS_QUESTION_COPY =  'is_question_copy';
export const RESET_QUESTION_COPY = 'reste_question_copy';

//Answers
export const LOAD_ANSWERS_SUCCESS = 'load_answers_success';
export const RESET_ANSWERS = 'reset_answers';
export const REORDER_ANSWERS_SUCCESS = 'reorder_answers_success';

// Meal Deals 
export const LOAD_SUB_QUESTIONS_SUCCESS = 'load_sub_questions_success';
export const RESET_SUB_QUESTIONS = 'reset_sub_questions';
export const REORDER_SUB_QUESTIONS_SUCCESS = 'reorder_sub_questions_success'
export const LOAD_SUB_ANSWERS_SUCCESS = 'load_sub_answers_success';
export const RESET_SUB_ANSWERS = 'reset_sub_answers';
export const REORDER_SUB_ANSWERS_SUCCESS = 'reorder_sub_answers_success';

// OrderHistory
export const LOAD_ORDERS_HISTORY_SUCCESS = 'load_orders_history_success';
export const CLEAR_ORDERS_HISTORY = 'clear_orders_history';

//Order Details
export const LOAD_ORDER_DETAILS_SUCCESS = 'load_order_details_success';
export const LOAD_RESTAURANT_DETAILS_SUCCESS = 'load_restaurant_details_success';
export const LOAD_REFUND_HISTORY_SUCCESS = 'load_refund_history_success';
export const CLEAR_ORDER_DETAILS = 'clear_order_details';

// DependsOn questions
export const LOAD_DEPENDS_ON_QUESTIONS_SUCCESS = 'load_depends_on_questions_success';

// Job History
export const LOAD_JOB_HISTORY_SUCCESS = 'load_job_history_success';
export const LOAD_JOB_DETAILS_SUCCESS = 'load_job_details_success';
export const LOAD_JOB_PAYLOAD_SUCCESS = 'load_job_payload_success';
export const LOAD_JOB_ITEMS_SUCCESS = 'load_job_items_success';
export const CLEAR_JOB_DETAILS = 'clear_job_details';
export const CLEAR_PAYLOAD = 'clear_payload';


// Restaurant Opening Hours
export const LOAD_OPENING_HOURS_SUCCESS = 'load_opening_hours_success';
export const CLEAR_OPENING_HOURS = 'clear_opening_hours';

//Taxes
export const LOAD_TAX_BANDS_SUCCESS = 'load_tax_bands_success';
export const LOAD_TAX_SETTINGS_SUCCESS = 'load_tax_settings_success';
export const SAVE_TAX_SETTINGS_SUCCESS = 'save_tax_settings_success';
export const CLEAR_TAX_SETTINGS = 'clear_tax_settings';

// Service Settings - General
export const LOAD_RESTAURANT_SETTINGS_SUCCESS = 'load_restaurant_settings_success';
export const LOAD_ORDER_TYPES_SUCCESS = 'load_order_types_success';
export const UPDATE_RESTAURANT_SETTINGS_SUCCESS = 'update_restaurant_settings_success';
export const CLEAR_ORDER_TYPES = 'clear_order_types';

// Service Settings - Delivery
export const LOAD_TENDER_TYPES_SUCCESS = 'load_all_tender_types_success';
export const LOAD_DELIVERY_SETTINGS_SUCCESS = 'load_delivery_settings_success';
export const UPDATE_DELIVERY_SETTINGS_SUCCESS = 'update_delivery_settings_success';
export const RESET_DELIVERY_SETTINGS = 'reset_delivery_settings';
export const RESET_TENDER_TYPES = 'reset_tender_types';

// Service Settings - Collection
export const LOAD_COLLECTION_SETTINGS_SUCCESS = 'load_collection_settings_success';
export const UPDATE_COLLECTION_SETTINGS_SUCCESS = 'update_collection_settings_success';
export const RESET_COLLECTION_SETTINGS = 'reset_collection_settings';

// Service Settings - Dine In
export const LOAD_DINEIN_SETTINGS_SUCCESS = 'load_dinein_settings_success';
export const UPDATE_DINEIN_SETTINGS_SUCCESS = 'update_dinein_settings_success';
export const RESET_DINEIN_SETTINGS = 'reset_dinein_settings';

// Service Settings - Curbside
export const LOAD_CURBSIDE_SETTINGS_SUCCESS = 'load_curbside_settings_success';
export const UPDATE_CURBSIDE_SETTINGS_SUCCESS = 'update_curbside_settings_success';
export const RESET_CURBSIDE_SETTINGS = 'reset_curbside_settings';

// Service Settings - In Store
export const LOAD_INSTORE_SETTINGS_SUCCESS = 'load_instore_settings_success';
export const UPDATE_INSTORE_SETTINGS_SUCCESS = 'update_instore_settings_success';
export const RESET_INSTORE_SETTINGS = 'reset_instore_settings';
export const GET_ALL_RESTAURANT_MENUS = 'get_all_restaurant_menus';

//Notifications

export const LOAD_NOTIFICATIONS_SUCCESS = 'load_notifications_success';
export const PUBLISH_IN_PROGRESS = 'publish_in_progress';
export const PUBLISH_IN_PROGRESS_FINISHED = 'publish_in_progress_finished';

export const IMPORT_IN_PROGRESS = 'import_in_progress';
export const IMPORT_IN_PROGRESS_FINISHED = 'import_in_progress_finished';

//Promotions
export const LOAD_PROMOTIONS_SUCCESS = 'load_promotions_success';
export const LOAD_PROMOTIONS_SUMMARY_SUCCESS = 'load_promotions_summary_success';
export const LOAD_RESTAURANT_PRODUCTS_SUCCESS = 'load_restaurant_products_success';
export const LOAD_PROMOTIONS_PROMO_CODES_SUCCESS = 'load_promotions_promo_codes_success';
export const SAVE_PROMOTION_SUCCESS = 'save_promotion_success';
export const UPDATE_PROMOTION_SUCCESS = 'update_promotion_success';
export const DELETE_PROMOTION_SUCCESS = 'delete_promotion_success';
export const UPDATE_PROMOTION_IMAGE_SUCCESS = 'update_promotion_image_success';
export const DELETE_PROMOTION_IMAGE_SUCCESS = 'delete_promotion_image_success';
export const LOAD_PROMOTIONS_SEARCH_SUCCESS = 'load_promotions_search_success';

//Reports
export const LOAD_REPORT = 'load_report';
export const DOWNLOAD_PRODUCT_REPORT_ERROR = 'download_product_report_error';
//AllergensAndDietaryInfo
export const LOAD_ALL_ALLERGENS_SUCCESS = 'load_all_allergens_success';
export const LOAD_ALL_DIETARY_INFO_SUCCESS = 'load_all_dietary_info_success';
export const LOAD_ALL_NUTRIENTS_SUCCESS = 'load_all_nutrients_success';

// Service fees
export const GET_SERVICE_FEES_SUCCESS = 'get_service_fees_success';

//Loyalty
export const GET_LOYALTY = 'get_loyalty';
export const SAVE_LOYALTY_SUCCESS = 'save_loyalty_success';
export const DELETE_LOYALTY = 'delete_loyalty';
export const DELETE_LOYALTY_IMAGE = 'delete_loyalty_image';
export const LOAD_LOYALTY_USERS = 'load_loyalty_users';
export const CLEAR_LOYALTY_USERS = 'clear_loyalty_users';
export const LOAD_USER_PROMOCODES = 'load_user_promocodes';
export const IS_LOYALTY_NOT_FOUND = 'is_loyalty_not_found';

//Upsell
export const FETCH_UPSELL_SETTINGS = 'fetch_upsell_settings';
export const REORDER_UPSELL_PRODUCTS = 'reorder_upsell_products';
export const CLEAR_UPSELL_SETTINGS = 'clear_upsell_settings';

// Central Orders Log
export const GET_CENTRAL_ORDERS_LOG_SUCCESS = 'get_central_orders_log_success';
export const GET_BRAND_AND_REST_NAMES = 'get_brand_and_rest_names';

//Delivery Partners
export const GET_DELIVERY_PARTNERS = 'get_delivery_partners';
export const GET_RESTAURANT_DELIVERY_PARTNER_SETTINGS = 'get_restaurant_delivery_partner_settings';
export const RESET_RESTAURANT_DELIVERY_PARTNER_SETTINGS = 'reset_restaurant_delivery_partner_settings';
export const SAVE_DELIVERY_PARNER_SETTINGS = 'save_delivery_partner_settings';

//Survey Partners
export const GET_SURVEY_PARTNERS = 'get_survey_partners';
export const GET_RESTAURANT_SURVEY_PARTNER_SETTINGS = 'get_restaurant_survey_partner_settings';
export const RESET_RESTAURANT_SURVEY_PARTNER_SETTINGS = 'reset_restaurant_survey_partner_settings';
export const SAVE_SURVEY_PARNER_SETTINGS = 'save_survey_partner_settings';

//Push Notifications
export const FETCH_PUSH_NOTIFICATIONS = 'fetch_push_notifications';

//System Control

export const LOAD_RESTRICTIONS_SUCCESS = 'load_restrictions_success';
export const CLEAR_RESTRICTIONS = 'clear_restrictions';
export const BATCH_RESEND_SUCCESS = 'batch_resend_success';
export const LOAD_CRON_JOB_BY_TIME_SUCCESS = 'load_cron_job_by_time_success';

// Promotion Providers
export const LOAD_PROMOTION_PROVIDERS_SUCCESS = 'load_promotion_providers_succes';
export const LOAD_SELECTED_PROMO_PROVIDER_SUCCESS = 'load_selected_promo_provider_success';
export const TOGGLE_CHAIN_LEVEL_PROMOTION_SETTINGS = 'toggel_chain_level_promotion_settings';
export const SAVE_CURRENT_DB_CAPACITY = 'save_current_db_capacity';
export const GET_ALL_SCHEDULED_SETTINGS = 'get_all_scheduled_settings';

// Event Tracking
export const GET_EVENT_TRACKING_LOG_SUCCESS = 'get_event_tracking_log_success';
export const GET_SELECTED_USER_SUCCESS = 'get_selected_user_success';

// Language
export const CHANGE_LANGUAGE = 'change_language';

// Customer Insight
export const LOAD_CUSTOMER_INSIGHT = 'load_customer_insight';
export const LOAD_CUSTOMER_INSIGHT_DISABLED = 'load_customer_insight_disabled';
export const LOAD_CUSTOMER_INSIGHT_ORDER_TYPE_SEARCH = 'load_customer_insight_order_type_search';
export const LOAD_CUSTOMER_INSIGHT_PAYMENT_TYPE_SEARCH = 'load_customer_insight_payment_type_search';
export const LOAD_CUSTOMER_INSIGHT_SOURCE_TYPE_SEARCH = 'load_customer_insight_source_type_search';
export const LOAD_CUSTOMER_INSIGHT_ORDER_FREQUENCY_SEARCH = 'load_customer_insight_order_frequency_search';
export const LOAD_CUSTOMER_INSIGHT_DAILY_ORDER_FREQUENCY_SEARCH = 'load_customer_insight_daily_order_frequency_search';
export const LOAD_CUSTOMER_INSIGHT_PRODUCT_SUMMART_SEARCH = 'load_customer_insight_product_summary_search';
export const LOAD_CUSTOMER_INSIGHT_PROMOTION_SUMMARY_SEARCH = 'load_customer_insight_promotion_summary_search';
export const LOAD_CUSTOMER_INSIGHT_PROMOTION_SEARCH = 'load_customer_insight_promotion_search';
export const LOAD_CUSTOMER_INSIGHT_PROMOTION_NAMES = 'load_customer_insight_promotion_names';
export const LOAD_CUSTOMER_INSIGHT_REFUND_SEARCH = 'load_customer_insight_refund_search';
export const LOAD_CUSTOMER_INSIGHT_ORDER_SEARCH = 'load_customer_insight_order_search';
export const LOAD_CUSTOMER_INSIGHT_NOTIFICATION_SEARCH = 'load_customer_insight_notification_search';

// Restaurant Insight
export const LOAD_RESTAURANT_INSIGHT = 'load_restaurant_insight';
export const LOAD_RESTAURANT_INSIGHT_DISABLED = 'load_restaurant_insight_disabled';
export const ENABLE_DISABLE_RESTAURANT_INSIGHT = 'enable_disable_restaurant_insight';
export const LOAD_RESTAURANT_INSIGHT_PRODUCT_SUMMARY_SEARCH = 'load_restaurant_insight_product_summary_search';
export const LOAD_RESTAURANT_INSIGHT_PROMOTION_SUMMARY_SEARCH = 'load_restaurant_insight_promotion_summary_search';
export const LOAD_RESTAURANT_INSIGHT_PROMOCODES_SUMMARY_SEARCH = 'load_restaurant_insight_promocodes_summary_search';
export const LOAD_RESTAURANT_INSIGHT_HOURLY_ORDER_FREQUENCY_SEARCH = 'load_restaurant_insight_hourly_order_frequency_search';
export const LOAD_RESTAURANT_INSIGHT_DAILY_ORDER_FREQUENCY_SEARCH = 'load_restaurant_insight_daily_order_frequency_search';
export const LOAD_RESTAURANT_INSIGHT_ORDER_TYPE_SEARCH = 'load_restaurant_insight_order_type_search';
export const LOAD_RESTAURANT_INSIGHT_SOURCE_TYPE_SEARCH =  'load_restaurant_insight_source_type_search';
export const LOAD_RESTAURANT_INSIGHT_PAYMENT_TYPE_SEARCH = 'load_restaurant_insight_payment_type_search';

// Subscription
export const SAVE_SUBSCRIPTION_SUCCESS = 'save_subscription_success';
export const LOAD_SUBSCRIPTION_SUCCESS = 'load_subscription_success';
export const GET_SUBSCRIPTION_SUCCESS = 'get_subscription_success';

// Additional Charges
export const LOAD_ADDITIONAL_CHARGES_SUCCESS = 'load_additional_charges_success';
export const CREATE_ADDITIONAL_CHARGE_SUCCESS = 'create_additional_charge_success';
export const LOAD_ADDITIONAL_CHARGES_HISTORY_SUCCESS = 'load_additional_charges_history_success';

// Company Info
export const LOAD_COMPANY_INFO_SUCCESS =  'load_company_info_success';

// Bank Account
export const LOAD_BANK_ACCOUNT_SUCCESS = 'load_bank_account_success';

// Invoices
export const LOAD_INVOICES_SUCCESS = 'load_invoices_success';
export const GET_INVOICE_DATA_SUCCESS = 'get_invoice_data_success';

// Billing Dashboard
export const GET_SYSTEM_STATISTIC_SUCCESS = 'get_system_statistic_success';
export const GET_INVOICE_COLLECTION_SUCCESS = 'get_invoice_collection_success';
export const GET_MONTHLY_SYSTEM_STATISTIC_SUCCESS = 'get_monthly_system_statistic_success';
export const GET_MONTHLY_PAYABLE_RECON_SUCCESS = 'get_monthly_payable_recon_success';

//Giftcard Providers
export const GET_GIFTCARD_PROVIDERS = 'get_giftcard_providers';
export const GET_RESTAURANT_GIFTCARD_PROVIDER_SETTINGS = 'get_restaurant_giftcard_provider_settings';
export const RESET_RESTAURANT_GIFTCARD_PROVIDER_SETTINGS = 'reset_restaurant_giftcard_provider_settings';
export const GET_RESTAURANT_GIFTCARD_PROVIDER_TYPE_ID = 'get_restaurant_giftcard_provider_type_id';

// Marketing Automations
export const LOAD_MARKETING_AUTOMATIONS = 'load_marketing_automations';
export const LOAD_TRIGGER_IMAGES_SUCCESS = 'load_trigger_images_succes';
export const REORDER_SECTION_ITEMS = 'reorder_section_items';
export const LOAD_MARKETING_AUTOMATIONS_DISABLED = 'load_marketing_automations_disabled';
export const SELECT_MARKETING_AUTOMATION = 'select_marketing_automation';
export const INITIAL_AUDIENCE = 'initial_audience';
export const LOAD_CUSTOMER_AUTOMATION_SEARCH =  'load_customer_automation_search';
export const BLOCK_UNBLOCK_CUSTOMER = 'block_unblock_customer';
export const CHECK_ADD_CUSTOMER =  'check_add_customer';
export const ADD_CUSTOMER = 'add_customer';
export const CLEAR_CUSTOMER_TO_ADD = 'clear_customer_to_add';

// Customers Status Search
export const GET_CUSTOMER_INFO_SEARCH = 'get_customer_info_search';
export const IS_INSIGHTS_DISABLED = 'is_insights_disabled';


// WEBPACK FOOTER //
// ./src/actions/types.js